import React from "react";
import download_icon from "@assets/images/download_icon.svg";
import constant from "@utils/constant";
import { useAppContext } from "@context/AppContext";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faXTwitter
} from "@fortawesome/free-brands-svg-icons";

const ShareModal = ({ card, onDownload, onClose }) => {
  const { themeConfig } = useAppContext();
  const imageUrl = card?.imagepng.replace(constant.ARWEAVE_LINK, "");
  const link = `${window.location.origin}/share?image=${imageUrl[1]}%26tokenId=${card.tokenId}`;
  const whatUserDid =
    card.numberOfTransfers === 0
      ? "minted"
      : card.numberOfTransfers > 0 && card.forSale
      ? "placed for sale"
      : "bought";
  const showTwitter = () => {
    const tweet = {
      text: `I just ${whatUserDid} a Fund Raisin %23NFT "${card.name.replace(
        "#",
        "%23"
      )}" from the ${themeConfig.APP_CAMPAIGN_NAME} to help raise money for @${themeConfig.APP_BENEFICIARY}.`,
      url: link,
      hashtags: `AwardNFTs,Avalanche`,
    };
    const twitterLink = `${constant.TWITTER_API}url=%0A${tweet.url}%0A&text=${tweet.text}%0A&hashtags=${tweet.hashtags}`;
    if (imageUrl[1]) {
      return (
        <a href={twitterLink} target="_blank" rel="noreferrer">
          <div className="nft__twitter-btn">
            <div className="nft__twitter-icon">
            <FontAwesomeIcon
              icon={faXTwitter}
              style={{ height: "2rem", color: 'white' }}
            />
            </div>
          </div>
        </a>
      );
    }
  };
  return (
    <div className="share-modal">
      <div className="close-btn__wrapper" onClick={onClose}>
        <div className="close-btn__bar bar1"></div>
        <div className="close-btn__bar bar2"></div>
      </div>
      <div className="share-icons">
        <div className="nft__download-btn" onClick={() => onDownload(card)}>
          <img
            className="nft__download-icon"
            src={download_icon}
            alt="download"
          />
        </div>
        {showTwitter()}
      </div>
    </div>
  );
};

export default ShareModal;
